import React from 'react';
import { Link } from 'react-router-dom';

export default class CourseLauncher extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            courseInfo: {}
        }
    }
    componentDidMount()
    {
        this.getCourseDetails();
    }
    getCourseDetails()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "GetCourse",
            method: "post",
            body: JSON.stringify({courseID: this.props.courseID}),
            success: (result) => {
                this.setState({loaded: true, courseInfo: result});
                console.dir(result);
                if (result.courseType === 0)
                {
                    window.open("/exam/" + result.courseID);
                }
            },
            error: (err) => {
                this.setState({loaded: true, error: true});
            }
        })
    }
    render()
    {
        return (
            <div className="lmsdisplayarea">
                {this.state.loaded? (
                    <div>
                        <h3>
                            {this.state.courseInfo.courseName}
                        </h3>
                        {this.state.error ? (
                            <div>An error occurred while loading this course.</div>
                        ) : this.state.courseInfo.owned ?
                            this.state.courseInfo.courseType === 1 ? (
                                <iframe className="lmsiframe" title="External Course Content"
                                src="https://lms.360training.com/lms/aicc.do?aicc_sid=Os3UEjrUBdaaUpXR0LOh&aicc_url=http://38.107.156.111&course_id=953bc365f21241ffb3881031226bd0d5&customer_id=VUCUS-25702">
                                </iframe>
                            ) : (
                                <div>
                                    Course loaded.  If course does not launch automatically, <a href={"/exam/" + this.state.courseInfo.courseID} className="bodylink" target="_blank" rel="noopener noreferrer">
                                        click here</a>.
                                </div>
                            )
                        : (
                            <div>
                                There was a problem verifying course ownership.<br />
                                <Link to={"/Courses/" + this.props.courseID} className="bodylink">
                                Click here for course details.</Link>
                            </div>
                        )}
                    </div>
                ): (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/course/launchcourse.js